// extracted by mini-css-extract-plugin
export default {"root":"DoubleEntries_root__gvMFt","placeHolderShimmer":"DoubleEntries_placeHolderShimmer__bYP-g"};